import { useEffect } from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import { parksWebService } from '../helpers/parksWeb';

import {
  extractKeyFromPath,
  buildFinalRedirectUrl,
  hasProtocol
} from '../helpers/redirectUtils';

const notFoundUrl = "https://www.dreamworld.com.au/404-not-found";

const Redirect = () => {
  useEffect(() => {
    const fetchAndRedirect = async () => {
      const key = extractKeyFromPath(window.location.pathname);

      // Handle empty or whitespace-only keys
      if (!key) {
        console.warn('No valid key found in URL path');
        window.location.href = notFoundUrl;
        return;
      }

      let destinationUrl = notFoundUrl;
      try {
        const result = await parksWebService.getRedirectByKey(key);
        if (result?.url) {
          console.log(`Redirecting '${key}' to ${result.url}`);
          destinationUrl = result.url;
        }
      } catch (error) {
        console.error("Error fetching redirect data:", error);
      }

      // Merge query parameters and fragment from source and destination URLs
      const finalUrl = buildFinalRedirectUrl(
        destinationUrl,
        window.location.search,
        window.location.hash
      );

      // Handle protocol – don't add https:// if URL already has one
      window.location.href = hasProtocol(finalUrl) ? finalUrl : `https://${finalUrl}`;
    };

    fetchAndRedirect();
  }, []);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress color="info" size="80px" />
    </Box>
  );
};

export default Redirect;